import { FormEvent, useEffect, useState } from "react"
import { Button, Col, Form, Modal, OverlayTrigger, Popover, Row } from "react-bootstrap"
import removeAllErrorMsg from "../../components/funcRemoveAllErros"
import { ApiEndpoints, LinkEndpoint, reqGetDownloadFile, reqGetNew, reqPostNew, reqPut } from "../../config/apiClient"
import dayjs from "dayjs"
import { defineValueInInput } from "../../components/funcForInput"
import styles from './styles/modalCrachaHistorico.module.css'
import { toast } from "react-toastify"
import { getCookie } from "../../config/cookies"

export default function ModalColaboradorCrachaHistorico({ show, handleClose, colaborador }: iProps) {
    const [loading, setLoading] = useState<boolean>(false)
    const [historicoCrachas, setDadosHistorico] = useState<any[]>([])

    useEffect(() => {
        listarRegistros()
        // eslint-disable-next-line
    }, [])
    async function listarRegistros() {
        const colaboradoresCrachaHistorico: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/colaboradores/crachas/historico/${colaborador.id_colaborador}`,
            timeout: 10000
        }
        setLoading(true)
        const api = await reqGetNew(colaboradoresCrachaHistorico)
        if (api.status === 200) {
            console.log(api)
            setDadosHistorico(api.data)
            atualizarFormColaborador(api.data)
        }
        setLoading(false)
    }
    function atualizarFormColaborador(registros: any[]) {
        if (registros.length === 0) {
            defineValueInInput("data_cracha_impresso", "")
            return
        }
        const reg = registros[0]
        defineValueInInput("data_cracha_impresso", dayjs(reg.data_cracha_impresso).format("DD/MM/YYYY"))
    }

    function handleSubmitPlanilha(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form: any = event.target
        let formValidado = true

        let dados = {
            planilha: form.planilha.files,
        }
        console.log(dados)
        if (dados.planilha.length === 0) {
            form.planilha.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (!formValidado) {
            return
        }
        importar(dados)
    }

    async function importar(dadosImportar: any) {
        setLoading(true)

        const token = getCookie("token")
        const id_usuario = getCookie("id_user")
        let dados = new FormData()
        dados.append('planilha', dadosImportar.planilha[0])

        try {
            let api: Response
            let apiData = await fetch(
                ApiEndpoints.importarPlanilhaCrachasColaboradores.endpoint,
                {
                    method: "PATCH",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "id_usuario": id_usuario,
                    },
                    body: dados
                }
            ).then(response => {
                api = response
                return response.json()
            })
            if (api!.status === 200) {
                console.log(apiData)
                const atualizados: any[] = apiData.colaboradores
                window.alert(`Colaboradores atualizados (${atualizados.length})!`)
                listarRegistros()
                toast.success("Importação finalizada com sucesso!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            } else {
                toast.warn(String(apiData.message), {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        } catch (error) {
            console.log(error)
            toast.warn('Não foi possível importar, verifique se o layout está correto ou contate o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setLoading(false)
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form: any = event.target
        let formValidado = true
        let dados = {
            id: null,
            id_colaborador: colaborador.id_colaborador,
            data_cracha_impresso: form.data_emissao.value,
        }
        console.log(dados)
        if (dados.data_cracha_impresso === "") {
            form.data_emissao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (!formValidado) {
            return
        }

        cadastrar(dados)
    }

    async function cadastrar(dados: any) {
        setLoading(true)
        const api = await reqPut(ApiEndpoints.colaboradoresCrachaHistoricoAdicionar, dados)
        if (api.status === 201) {
            setDadosHistorico(api.data)
            defineValueInInput("data_emissao", "")
            atualizarFormColaborador(api.data)
        }
        setLoading(false)
    }

    async function removerRegistro(id: number) {
        setLoading(true)
        const dados = {
            id: id
        }
        const api = await reqPostNew(ApiEndpoints.colaboradoresCrachaHistoricoDeletar, dados)
        if (api.status === 200) {
            setDadosHistorico(api.data)
            atualizarFormColaborador(api.data)
            toast.success('Registro deletado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }

    async function relatorio() {
        setLoading(true)
        let arquivo:string = `Relatorio-Controle-Cracha-${dayjs().format("DD-MM-YYYY")}.pdf`
        let response = await reqGetDownloadFile(ApiEndpoints.relatorioCrachasColaboradores, arquivo)
        if (response.status === 200) {
            toast.success('Aguarde o termino do download...', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }

    const popover = (
        <Popover id="popover-basic" style={{ minWidth: "600px" }}>
            <Popover.Header as="h3">Exemplo Layout (Colunas)</Popover.Header>
            <Popover.Body>
                <Row>
                    <Col className="col-12">
                        <p><b>Tipo do arquivo*:</b> .xlsx</p>
                        <p><b>matricula*:</b> 999 (número)</p>
                        <p><b>cpf*:</b> 123.456.789-00 (texto)</p>
                        <p><b>data_admissao*:</b> 01/01/1999 (data)</p>
                        <p><b>data_emissao*:</b> 01/01/1999 (data)</p>
                        <p>Outras colunas serão desconsideradas.</p>
                        <br />
                        <p><b>Obs.:</b> Não é necessário estar na ordem acima, as colunas precisam apenas existir na planilha com o mesmo nome, caso faltar 1 ou mais, a importação não será realizada.</p>
                    </Col>
                </Row>
            </Popover.Body>
        </Popover>
    )

    return (
        <Modal
            id="modalCrachaHistorico"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Colaborador Crachá Histórico</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formImportarCrachas`} onSubmit={handleSubmitPlanilha} noValidate>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Arquivo:</Form.Label>
                                <Form.Control type="file" name="planilha" id="planilha" aria-label="Selecione a Planilha" accept=".xlsx"></Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    Selecione o arquivo!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <Button type="submit" disabled={loading} style={{ marginRight: "10px" }}>{loading ? "Aguarde..." : "Importar"}</Button>

                    <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                        <Button variant="success" style={{ marginRight: "10px" }}>Layout</Button>
                    </OverlayTrigger>

                    <Button disabled={loading} style={{ marginRight: "10px" }} onClick={() => { relatorio() }} >{loading ? "Aguarde..." : "Relatório"}</Button>
                </Form>
                <hr></hr>
                <Form id={`formAtualizarCracha`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Colaborador: {colaborador.matricula} - {colaborador.nome_completo}</Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Data impressão último Crachá:</Form.Label>
                                <Form.Control type="date" name="data_emissao" id="data_emissao"></Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    Informe a data!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <Button type="submit" disabled={loading} style={{ marginRight: "10px" }}>{loading ? "Aguarde..." : "Adicionar"}</Button>
                </Form>
                <br></br>
                {
                    historicoCrachas.length === 0 &&
                    <div>
                        <p>Sem registros.</p>
                    </div>
                }

                {
                    historicoCrachas.length > 0 &&
                    <div>
                        <Row style={{ fontWeight: 'bold' }}>
                            <Col className="col-4">Data impresso ({historicoCrachas.length})</Col>
                        </Row>
                        <br></br>
                    </div>
                }

                {
                    historicoCrachas.length > 0 &&
                    <div>
                        {
                            historicoCrachas.map((reg: any, idx: any) => (
                                <div key={idx} className="div-row" style={{ alignItems: 'center', marginRight: "10px" }}>
                                    <p>{dayjs(reg.data_cracha_impresso).format("DD/MM/YYYY")}</p>
                                    <p className={styles.btnDelete}>
                                        <span className="material-symbols-outlined" onClick={() => { removerRegistro(reg.id) }}>
                                            delete
                                        </span>
                                    </p>
                                    <p style={{ marginLeft: "20px" }}>Atualizado em: {dayjs(reg.data_criacao).format("DD/MM/YYYY - HH:mm:ss")}</p>
                                </div>
                            ))
                        }
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

interface iProps {
    show: boolean
    handleClose: any
    colaborador: any
}